import { RewardPeriod, RewardType } from '@loyalty/shared-common/rewards-api-client';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function useRewardName() {
  const { t } = useTranslation();
  return useMemo<{ [key in RewardType]: string }>(
    () => ({
      [RewardType.PROMOCODE]: t('rewards.selection.promocodes'),
      [RewardType.CAMPAIGN_ACCESS]: t('rewards.selection.campaign'),
      [RewardType.CAMPAIGN_CODE]: t('rewards.selection.campaign-code'),
    }),
    [t],
  );
}

export function usePeriodValue() {
  const { t } = useTranslation();
  return useMemo<{ [key in RewardPeriod]: string }>(
    () => ({
      [RewardPeriod.MINUTE]: t('reward.campaign.periodicity.minute'),
      [RewardPeriod.HOUR]: t('reward.campaign.periodicity.hour'),
      [RewardPeriod.DAY]: t('reward.campaign.periodicity.day'),
    }),
    [t],
  );
}
